The text value of the answer.

For `FreeText` questions this may contain whitespace such as the `\n` newline escape sequence.
For readability, you should display [whitespace characters](https://developer.mozilla.org/en-US/docs/Web/CSS/white-space) instead of collapsing them.
